import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset, IProfileFilter, ITree, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import * as _ from "lodash"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {CustomerSearch} from "../PA.UIM.MD/CustomerSearch";
import {PlanningLevelSearch} from "./PlanningLevelSearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {ProductSearch} from "../PA.UIM.MD/ProductSearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";

const TPMPlanSearch: ISearch = {
    searchName: "Find SVF",
    renderOptions: {ui5ResourceId: "TPMPlanSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: []
}

const vUI_TPM_Plan_Search_Fields: { [id: string]: ISearchProviderField } = {

    WB_PLAN_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB Plan Id', columnResourceName: 'colId', alignment: HorizAlignment.Center},
        domainOptions: {}
    },
    PLAN_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Plan Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    PLAN_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Plan Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },

    WB_CUST_ID_PLANNING: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Planning Cust WB Id',
            columnResourceName: 'colPlnCstId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {search: CustomerSearch, profileId: "MyPlanningCustomers", searchCondition: {}}
    },
    PLANNING_CUSTOMER_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Planning Customer',
            columnResourceName: 'colPlnCst',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: TPMPlanSearch,
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 256
        }
    },

    PLANNING_CUSTOMER_TREE_PATH: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Planning Customer',
            columnResourceName: 'colPlnCst',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },

    WB_PLANM_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Plan Type ID',
            columnResourceName: 'colPlanTypeID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    PLANTYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Plan Type', columnResourceName: 'colPlanTypeName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },

    SALESORG: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Sales Org', columnResourceName: 'colSalesOrg', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 20}
    },
    DIVISION: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Division', columnResourceName: 'colDivision', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 20}
    },
    DISTRIBCHANNEL: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Distrib Channel',
            columnResourceName: 'colDistribChannel',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 20}
    },

    INSTORE_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'InStore Start Dt',
            columnResourceName: 'colInStoreStart',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    INSTORE_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'InStore End Dt',
            columnResourceName: 'colInStoreEnd',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },

    SOURCE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Source ID', columnResourceName: 'colSourceId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50, source: true, useIdAsKey: true}
    },

    ACTIVE_IND: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Active Ind', columnResourceName: 'colActiveInd', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 5}
    },

    PLANNING_LEVEL_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Planning Level ID',
            columnResourceName: 'colLevelID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50, search: PlanningLevelSearch, profileId: "", searchCondition: {}}
    },
    PLANNING_LEVEL_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Planning Level',
            columnResourceName: 'colLevelName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },

    PLAN_PERIOD_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Plan Period',
            columnResourceName: 'colPlanPeriodName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: TPMPlanSearch,
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 256
        }
    },

    MANUAL_IND: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Manual Ind', columnResourceName: 'colManualInd', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 5}
    },

    EVENT_COUNT: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Event Count',
            columnResourceName: 'colEventCount',
            alignment: HorizAlignment.Right,
            numberFormat: "#,##0"
        },
        domainOptions: {}
    },

    LAST_CALC_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Last Calc Dt',
            columnResourceName: 'colLastCalcDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    LAST_CALC_TM: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Last Calc Tm',
            columnResourceName: 'colLastCalcTm',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }

}


const TPMPlanSearchProviderBasic: ISearchProvider =
    {
        keyFields: {
            id: 'WB_PLAN_ID',
            id_ui: 'PLAN_ID',
            name: 'PLAN_NAME',
            source_id: 'SOURCE_ID'
        },

        searchProviderFields: vUI_TPM_Plan_Search_Fields,


        search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
            let results: any[]


            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_TPM_Plan_Search',
                this.searchProviderFields,
                [])
            if (_.isEmpty(findRequest.order)) {
                findRequest.order = ['PLANNING_CUSTOMER_NAME', 'PLANNING_LEVEL_NAME']
            }

            async function searchPlans(findRequest: any) {
                try {
                    let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                    if (!usrContext.hasRoleId('VIEW_ALL')) {
                        await SearchUtils.addUserGroupPlansFilter(findRequest, 'WB_PLAN_ID')
                    }

                    results = await PASearch.findByRequest(findRequest)

                    return results
                } catch (err) {
                    console.log("failed to retrieve plans: " + err)
                }
            }

            return searchPlans(findRequest)
        },

        distinctValues(fieldName: string): Promise<string[] | number[]> {
            let results: string[] | number[] = []
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_TPM_Plan_Search',
                this.searchProviderFields,
                [fieldName])

            async function searchDistinctPlans(findRequest: ISearchRequest) {
                try {

                    let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                    if (!usrContext.hasRoleId('VIEW_ALL')) {
                        SearchUtils.addUserGroupPlansFilter(findRequest, 'WB_PLAN_ID')
                    }
                    let res = await PASearch.findByRequest(findRequest)
                    results = _.map(res, (aRow) => {
                        return aRow[fieldName]
                    })
                    return results

                } catch (err) {
                    console.log("failed to retrieve plans: " + err)
                }

            }

            return searchDistinctPlans(findRequest)
        }
    }


const TPMPlanSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Customer, Plan Name",
    renderOptions: {ui5ResourceId: "TPMPlanSearchProfileByName"},


    profileFilter: [
        //{profileFilterName: 'Customer',        searchProviderFieldId: 'WB_CUST_ID_PLANNING',    bMultiSelect: true, renderOptions: { }},
        {
            profileFilterName: 'Customer',
            searchProviderFieldId: 'PLANNING_CUSTOMER_NAME',
            bMultiSelect: true,
            renderOptions: {}
        },
        {profileFilterName: 'Plan Id', searchProviderFieldId: 'PLAN_ID', renderOptions: {}, bQuickSearch: true},
        {profileFilterName: 'Plan Name', searchProviderFieldId: 'PLAN_NAME', renderOptions: {}, bQuickSearch: true},
        {
            profileFilterName: 'Fiscal Year',
            searchProviderFieldId: 'PLAN_PERIOD_NAME',
            bMultiSelect: true,
            renderOptions: {}
        },
        {
            profileFilterName: 'Customer Name',
            searchProviderFieldId: 'PLANNING_CUSTOMER_NAME',
            renderOptions: {},
            bQuickSearch: true,
            bHidden: true
        }
    ],  // ISearchFields
    profileDisplayFields: [
        'PLANNING_CUSTOMER_NAME', 'PLANNING_LEVEL_NAME', 'PLAN_PERIOD_NAME', 'PLANTYPE_NAME', 'PLAN_NAME', 'PLAN_ID', 'SOURCE_ID',
        {
            columnTitle: "InStore Dates",
            fields: ['INSTORE_START_DT', 'INSTORE_END_DT'],
            seperator: " - ",
            alignment: HorizAlignment.Center
        },
        'EVENT_COUNT', {
            columnTitle: "Lock",
            lockClass: "TPMPlan",
            lockIdFieldName: "WB_PLAN_ID",
            bDisplayLockIcon: true,
            bDisplayLockOwner: true
        },
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: TPMPlanSearchProviderBasic,

    profileTreeIdDefault: "ByPlanningCustomer",
    profileTrees: [
        {
            treeId: "ByPlanningCustomer",
            treeName: "By Planning Customer",
            nodeProviders: [new ColumnNodeProvider(['PLANNING_CUSTOMER_NAME'], {defaultValues: "Empty Planning Customer"})],
            renderOptions: {}
        },
        {
            treeId: "ByPlanningLevel",
            treeName: "By Planning Level",
            nodeProviders: [new ColumnNodeProvider(['PLANNING_LEVEL_NAME'], {defaultValues: "Empty Planning Level"})],
            renderOptions: {}
        },
        {
            treeId: "ByPlanningCustomerLevel",
            treeName: "By Planning Customer/ Level",
            nodeProviders: [new ColumnNodeProvider(['PLANNING_CUSTOMER_NAME', 'PLANNING_LEVEL_NAME'], {defaultValues: ["Not Set", "Not Set"]})],
            renderOptions: {}
        }
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


TPMPlanSearch.searchProfiles = [TPMPlanSearchProfileByName]

PAEnvironment.registerBusinessObjectSearch("TPMPlanBO", "TPMPlan", TPMPlanSearch, "TPM Plan Search")

export {TPMPlanSearch}



class TPMPlanSearchProfile implements ISearchProfile {
    aSearchProvider: ISearchProvider = undefined

    profileId = "default"
    profileName = "Search By Customer, Plan Name"
    renderOptions = {ui5ResourceId: "TPMPlanSearchProfile"}

    profileFilter: IProfileFilter[] = [
        {profileFilterName: 'Plan Id', searchProviderFieldId: 'PLAN_ID', renderOptions: {}, bQuickSearch: true},
        {profileFilterName: 'Plan Name', searchProviderFieldId: 'PLAN_NAME', renderOptions: {}, bQuickSearch: true},
        {
            profileFilterName: 'Fiscal Year',
            searchProviderFieldId: 'PLAN_PERIOD_NAME',
            bMultiSelect: true,
            renderOptions: {}
        }
    ]

    profileDisplayFields = [
        'PLANNING_CUSTOMER_NAME', 'PLANNING_LEVEL_NAME', 'PLAN_PERIOD_NAME', 'PLANTYPE_NAME', 'PLAN_NAME', 'PLAN_ID', 'SOURCE_ID',
        {
            columnTitle: "InStore Dates",
            fields: ['INSTORE_START_DT', 'INSTORE_END_DT'],
            seperator: " - ",
            alignment: HorizAlignment.Center
        }
    ]

    profileTreeIdDefault = "default"
    profileTrees: ITree[] = []

    profileSortIdDefault = ""    //string;
    profileSorts: ISearchSort[] = [] //ISearchSort[];


    constructor() {
        this.aSearchProvider = TPMPlanSearchProviderBasic
    }

    get profileSearchProvider() {
        return this.aSearchProvider
    }

}

export class TPMPlanSearchNoLock
    implements ISearch {

    constructor( options?: any) {
        this.searchProfiles = [new TPMPlanSearchProfile()]
    }

    searchName = "Select Plan(s)"
    renderOptions = {ui5ResourceId: "TPMPlanSearchProfile"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = true

}
